import { fetchAnalyzeCasesByStatus } from '@ge/feat-analyze/services';
import { range } from '@ge/util/array-utils';

const buildBatchForFetchAllCases = ({ batchSize, siteIds, status, pageNum, pageSize }) =>
  range(batchSize, pageNum).map((pageNumber) => {
    return fetchAnalyzeCasesByStatus(siteIds, status, pageNumber, pageSize);
  });
const loadAllCases = async (siteIds, status, pageNum, pageSize) => {
  let allCases = [];
  const loadFeature = async () => {
    let totalPages = 0;
    try {
      let firstPage;
      firstPage = await fetchAnalyzeCasesByStatus(siteIds, status, pageNum, pageSize);
      totalPages = firstPage?.data?.totalPages;
      allCases = firstPage?.data?.mappedAllCases;
      if (!totalPages || totalPages <= 1) return;
      // Getting remaining pages;
      const remainingPages = totalPages - 1;
      let batchResults;
      batchResults = await Promise.allSettled(
        buildBatchForFetchAllCases({
          batchSize: remainingPages,
          siteIds,
          status,
          pageNum: 1,
          pageSize,
        }),
      );
      // try to push forward eagerly by only evaluating successful calls to see if we hit the last page
      // TOOD: revisit this approach
      const nonEmptyResult = batchResults.filter(
        ({ value }) => value && value?.data?.mappedAllCases?.length > 0,
      );
      let allCasesArr = nonEmptyResult.map(({ value }) => value?.data?.mappedAllCases);
      let flattenArr = [].concat.apply([], allCasesArr);
      allCases = allCases.concat(flattenArr);
    } catch (err) {
      console.error('Batch fetch error ', err);
    }
  };
  await loadFeature();
  return { data: allCases };
};

export const fetchAllCases = async (siteIds, status, pageNum, pageSize) => {
  return loadAllCases(siteIds, status, pageNum, pageSize);
};
